import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule, FormFieldModule, RectModule, TimerModule } from '@shared/components/games';
import { GamesSharedModule } from '../../games-shared/games-shared.module';
import { TilesControllerComponent } from './tiles-controller/tiles-controller.component';
import { TilesFieldComponent } from './tiles-field/tiles-field.component';
import { TilesCorrectAnswerPreviewComponent } from './tiles-preview/tiles-answer-preview/tiles-answer-preview.component';
import { TilesExamplePreviewComponent } from './tiles-preview/tiles-example-preview/tiles-example-preview.component';
import { TilesParametersPreviewComponent } from './tiles-preview/tiles-parameters-preview/tiles-parameters-preview.component';
import { TilesUserAnswerPreviewComponent } from './tiles-preview/tiles-user-answer-preview/tiles-user-answer-preview.component';
import { TilesSettingsComponent } from './tiles-settings/tiles-settings.component';
import { TilesRulesComponent } from './tools/tiles-rules/tiles-rules.component';

@NgModule({
  declarations: [
    TilesControllerComponent,
    TilesSettingsComponent,
    TilesRulesComponent,
    TilesCorrectAnswerPreviewComponent,
    TilesExamplePreviewComponent,
    TilesParametersPreviewComponent,
    TilesUserAnswerPreviewComponent,
    TilesFieldComponent,
  ],
  exports: [
    TilesControllerComponent,
    TilesSettingsComponent,
    TilesRulesComponent,
    TilesCorrectAnswerPreviewComponent,
    TilesExamplePreviewComponent,
    TilesParametersPreviewComponent,
    TilesUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    TimerModule,
    RectModule,
    FormFieldModule,
    GamesSharedModule,
  ],
})
export class TilesModule {}
